import { render, staticRenderFns } from "./ReminderCollate.vue?vue&type=template&id=49bcba7e&"
import script from "./ReminderCollate.vue?vue&type=script&lang=js&"
export * from "./ReminderCollate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports